define('lib/filtersFromVehicleId',[], function() {
   return function filtersFromVehicleId(vehicleId){
      var yearFromUrl = vehicleId;
      yearFromUrl = yearFromUrl.match(/YR_\d*/);
      yearFromUrl = yearFromUrl[0].split('_');
      yearFromUrl = parseInt(yearFromUrl[1]);

      var modelFromUrl = vehicleId;
      modelFromUrl = modelFromUrl.match(/MDL_\w*/);
      modelFromUrl = modelFromUrl[0].split('_');

      var xcolFromUrl = vehicleId;
      xcolFromUrl = xcolFromUrl.match(/XCOL_\w*/);
      xcolFromUrl = xcolFromUrl[0].split('_');

      var icolFromUrl = vehicleId;
      icolFromUrl = icolFromUrl.match(/ICOL_\w*/);
      icolFromUrl = icolFromUrl[0].split('_');

      var vehicleIdArr = vehicleId.split('-');
      var accFilterArr = [];
      var pkgFilterArr = [];
      for (var i = 0; i < vehicleIdArr.length; i++){
          var accFromUrl = vehicleIdArr[i].match(/ACY\ \w*/);
          var pkgFromUrl = vehicleIdArr[i].match(/PKG\ \w*/);

          if ( accFromUrl ) {
              accFromUrl = accFromUrl[0].split(' ')[1];
              accFilterArr.push(accFromUrl);
          }

          if ( pkgFromUrl ) {
              pkgFromUrl = pkgFromUrl[0].split(' ')[1];
              pkgFilterArr.push(pkgFromUrl);
          }
      };

      return {
          year: [yearFromUrl],
          model: [modelFromUrl[1]],
          exteriorcolor: [xcolFromUrl[1]],
          interiorcolor: [icolFromUrl[1]],
          accessory: accFilterArr,
          packages: pkgFilterArr

      }
  };
})
;
